// Shared timings keep navigation, reveals, and controls feeling like one system.
export const EASE_OUT = [0.22, 1, 0.36, 1] as const;
export const pageTransition = { duration: 0.32, ease: EASE_OUT };
export const controlTransition = { type: "spring", stiffness: 400, damping: 30 } as const;
